




















































































































































import { Vue, Component, Ref } from 'vue-property-decorator';
import { TextValuePair } from '@/models/TextValuePair';
import FilesUploader from '@/components/Form/FilesUploader.vue';
import { FileUpload } from '@/models/FileUpload';

@Component({
    components: {
        FilesUploader
    }
})
export default class ReturnForm extends Vue {
    [x: string]: any;
    private boardMailStart = 'bal.customerservice';
    private boardMailEnd = '.board@ticketeer.se';
    public issueType: string = '';
    public orderNumber: string = '';
    public customerMail: string = '';
    private customerName: string = '';
    public message: string = '';
    public issueReceived: boolean = false;
    public uploadedFiles: FileUpload[] = [];
    public fileUploaderError: boolean = false;
    public mounted() {
        const params = new URLSearchParams(window.location.search);
        if (params.get('return-product') === 'true') {
            this.issueType = 'return';
        }
        const ls = params.get('ls');
        if (ls) {
            this.orderNumber = ls;
        }
    }

    public clearCustomFieldError() {
        this.fileUploaderError = false;
    }

    public updateCustomField(val: any) {
        let files: FileUpload[] = [];
        let valueToStore: string = '';

        const looksLikeFileUpload = (obj: any) => {
            return (
                obj &&
                typeof obj === 'object' &&
                ('fileSystemId' in obj || 'fileName' in obj || 'originalFileName' in obj || 'fileUrl' in obj)
            );
        };

        if (Array.isArray(val) && val.length > 0 && looksLikeFileUpload(val[0])) {
            files = val as FileUpload[];
        } else if (looksLikeFileUpload(val)) {
            files = [val as FileUpload];
        }

        this.uploadedFiles = files;
    }

    public createTaskError: boolean = false;
    public getOrderError: boolean = false;
    public orderFound: boolean = false;
    private orderData: any = null;
    private moreThanOneOfProduct: any[] = [];
    public translations: any = window.__litium.translation;
    private checkBoxes: Array<string> = [
        'Returtransport bokad till Autoporten',
        'Retur ankomstkontrollerad på Autoporten',
        'Återbetald på Klarna',
        'Transport bokad till Returkompaniet',
        'Fakturerat Returkompaniet'
    ];
    get taskTitle(): string {
        if (this.orderNumberValid && this.mailValid) {
            switch (this.issueType) {
                case 'return':
                    return 'Retur - Order ' + this.orderNumber + ' - ' + this.customerMail;
                case 'complaint':
                    return 'Klagomål - Order ' + this.orderNumber + ' - ' + this.customerMail;
                default:
                    return '';
            }
        }
        return '';
    }

    get taskDescription(): string {
        let desc = 'Ordernummer: ' + this.orderNumber + '\n';
        if (this.orderData !== null) {
            desc += 'Länk till order: ' + this.orderData.link + '\n';
            desc += 'Namn: ' + this.orderData.firstName + ' ' + this.orderData.lastName + '\n';
            desc += 'Tel: ' + this.orderData.phone + '\n';
        }
        desc += 'E-post: ' + this.customerMail + '\n';
        if (this.productIssueList.length > 0) {
            desc += '\n*Berörda produkt(er)*\n';
            this.productIssueList.forEach(val => {
                if (val.quantity > 0) {
                    desc += '- ' + val.articleNumberNav + ' (' + val.quantity + '/' + val.ofQuantity + ')' + '\n';
                }
            });
        }
        desc += '\n*Beskrivning*\n';
        desc += this.message;
        if (this.uploadedFiles.length > 0) {
            desc += '\n\n*Bilder bifogade*';
            Array.from(Array(this.uploadedFiles.length).keys()).map(x => {
                desc += '\n- ' + this.uploadedFiles[x].fileName + ' : ' + this.uploadedFiles[x].fileUrl;
            });
        }
        return desc;
    }

    get orderNumberValid(): boolean {
        return /LS\d{6,7}$/i.test(this.orderNumber);
    }

    get mailValid(): boolean {
        return /^[^@\s]+@[^@\s]+\.[^@\s]+$/i.test(this.customerMail);
    }

    get filesSelected(): boolean {
        return this.uploadedFiles.length > 0;
    }

    get messageValid(): boolean {
        return this.message.length >= 20;
    }

    get productOptions(): TextValuePair[] {
        if (this.orderData !== null) {
            const returnArray = [] as TextValuePair[];
            this.orderData.orderRows.forEach((row: any) => {
                returnArray.push({
                    text: row.name,
                    value: row.articleNumberNav
                });
            });
            return returnArray;
        } else {
            return [] as TextValuePair[];
        }
    }

    get hasSelectedProduct(): boolean {
        if (this.moreThanOneOfProduct.filter(x => x.quantity > 0).length < 1) {
            return false;
        }

        return true;
    }
    get formComplete(): boolean {
        if (this.moreThanOneOfProduct.filter(x => x.quantity > 0).length < 1) {
            console.log('no products selected');
            return false;
        }
        if (!this.messageValid || (this.issueType === 'complaint' && !this.filesSelected)) {
            console.log('message valid: ' + this.messageValid + ' files selected: ' + this.filesSelected);
            console.log('message: ' + this.message);
            console.log('files: ' + this.uploadedFiles);
            return false;
        }
        return true;
    }

    get productIssueList(): Array<any> {
        this.moreThanOneOfProduct = (this.orderData.orderRows as Array<any>).map(x => {
            return { ...x, ofQuantity: x.quantity, quantity: 0 };
        });

        return this.moreThanOneOfProduct;
    }

    public decrease(obj: any) {
        if (obj.quantity > 0) obj.quantity -= 1;
    }

    public increase(obj: any): void {
        if (obj.ofQuantity > obj.quantity) obj.quantity += 1;
    }

    public updateFiles(e: Event) {
        this.files = (e.target as HTMLInputElement).files;
    }

    public async getOrder() {
        // this.orderFound = true
        const requestContext = (window as any).__litium.requestContext;
        const settings = {
            method: 'GET',
            headers: {
                'litium-request-context': JSON.stringify(requestContext)
            }
        };
        try {
            const fetchResponse = await fetch(
                '/api/returnform?orderId=' + this.orderNumber + '&email=' + encodeURIComponent(this.customerMail),
                settings
            );
            const data = await fetchResponse.json();
            if (!fetchResponse.ok) {
                this.getOrderError = true;
                throw new Error('Failed to fetch order');
            } else {
                console.log(data);
                this.orderData = data;
                this.orderFound = true;
            }
            return data;
        } catch (e) {
            return e;
        }
    }

    get jsonboxes(): string {
        return JSON.stringify(this.checkBoxes);
    }

    get boardMail(): string {
        return this.boardMailStart + this.boardMailEnd;
    }

    //Function that submits data to both Ticketeer and API
    public async submitIssue() {
        await this.sendToAPI();
        await this.sendToTicketeer();
    }

    public async sendToTicketeer() {
        if (this.formComplete) {
            this.createTaskError = false;
            let form = new FormData();
            form.append('message', this.taskDescription);
            form.append('subject', this.taskTitle);
            form.append('toMail', this.boardMail);
            form.append('fromMail', this.customerMail);
            form.append('checkBoxes', this.checkBoxes.join(','));
            const settings = {
                method: 'POST',
                body: form
            };
            try {
                const fetchResponse = await fetch('https://api.ticketeer.se/mailbox', settings);
                const data = await fetchResponse.json();
                if (!fetchResponse.ok) {
                    this.createTaskError = true;
                    throw new Error('Failed creating task');
                }
                this.issueReceived = true;
                return data;
            } catch (e) {
                return e;
            }
        }
    }

    public async sendToAPI() {
        if (this.formComplete) {
            this.createTaskError = false;
            const requestContext = (window as any).__litium.requestContext;
            const task = {
                orderId: this.orderNumber,
                email: this.customerMail,
                description: this.message,
                articles: this.checkBoxes,
                title: this.taskTitle,
                files: this.uploadedFiles,
                issueType: this.issueType,
                products: this.productIssueList
                    .filter(x => x.quantity > 0)
                    .map(x => {
                        return {
                            name: x.name,
                            articleNumberNav: x.articleNumberNav,
                            quantity: x.quantity,
                            ofQuantity: x.ofQuantity
                        };
                    })
            };
            const settings = {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'litium-request-context': JSON.stringify(requestContext)
                },
                body: JSON.stringify(task)
            };
            try {
                const fetchResponse = await fetch('/api/returnform', settings);
                const data = await fetchResponse.json();
                if (!fetchResponse.ok) {
                    this.createTaskError = true;
                    throw new Error('Failed submitting issue');
                }
                this.issueReceived = true;
                return data;
            } catch (e) {
                return e;
            }
        }
    }
}
